export const getPatientPassStatusLabel = (
  patientPassStatus: string
): { text: string; color: string } => {
  try {
    const map = {
      Active: {
        text: 'ACTIVE',
        color: 'primary'
      },
      Inactive: {
        text: 'INACTIVE',
        color: 'error'
      },
      Expired: {
        text: 'EXPIRED',
        color: 'error'
      }
    };

    const { text, color }: any = map[patientPassStatus];

    return { text, color };
  } catch {
    return { text: 'UNKNOWN', color: 'error' };
  }
};
